const defaultFetch = params => {
  let url = `api/crmpicklist/options/${params.entity}/${params.attribute}`;
  return rt.get(url);
};

export default {
  name: 'crmLookupPlugin',

  // 插件是否自动安装
  autoInstall: true,

  fetch: null,
  install (Vue, options) {
    Vue.prototype.$picklist = Vue.picklist = this;
  },
  resetFetch (fun) {
    this.fetch = fun || defaultFetch;
  },
  getPicklistData (params) {
    let fetchMethod = this.fetch || defaultFetch;
    return fetchMethod(params);
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/picklist/index.js